<template>
  <div>
    <div class="order-info">
      <div class="order-status">
        <van-icon name="passed" size="48" color="#07c160" v-if="userOrder.appointStatus == 1" />
        <van-icon name="passed" size="48" color="#1989fa" v-else-if="userOrder.appointStatus == 2" />
        <van-icon name="close" size="48" color="#ee0a24" v-else-if="userOrder.appointStatus == 9" />
        <h3>{{userOrder.appointStatus | orderStatus}}</h3>
      </div>
      <div class="order-detail" style="padding-bottom:16px;margin-bottom:16px; border-bottom: 1px solid #ebedf0;">
        <ul>
          <!-- <li>
            <span class="item-text">当前状态</span>
            <span class="item-value">{{userOrder.appointStatus | orderStatus}}</span>
          </li> -->
          <li>
            <span class="item-text">体检人员</span>
            <span class="item-value">{{userOrder.name}}</span>
          </li>
          <li>
            <span class="item-text">联系手机</span>
            <span class="item-value">{{userOrder.mobile | mask("phone")}}</span>
          </li>
          <li>
            <span class="item-text">体检机构</span>
            <span class="item-value">{{hospInfo.name}}</span>
          </li>
          <li>
            <span class="item-text">体检地点</span>
            <span class="item-value">{{hospInfo.address}}</span>
          </li>
          <li>
            <span class="item-text">体检时间</span>
            <span class="item-value">{{userOrder.appointDate}} {{userOrder.appointTimeRangeName}}</span>
          </li>
          <li>
            <span class="item-text">体检套餐</span>
            <span class="item-value">{{userOrder.packageName}}</span>
          </li>
          <li>
            <span class="item-text">预约编号</span>
            <span class="item-value">{{userOrder.orderNo}}</span>
          </li>
          <li v-if="userOrder&&userOrder.examNo">
            <span class="item-text">体检编号</span>
            <span class="item-value">{{userOrder.examNo}}
            </span>
          </li>
          <li v-if="userOrder&&userOrder.examUserCode">
            <span class="item-text">条码号</span>
            <span class="item-value">{{userOrder.examUserCode}}
              <br>
              <div class="barcode-wrap">
                <img id="barcode1"></img>
              </div>
            </span>
          </li>
        </ul>
      </div>
      <div class="order-detail" v-if="userOrder.payment>0">
        <ul>
          <!-- <li>
            <span class="item-text">当前状态</span>
            <span class="item-value">{{userOrder.appointStatus | orderStatus}}</span>
          </li> -->
          <li>
            <span class="item-text">订单金额</span>
            <span class="item-value" style="color:#EE0A24">{{userOrder.totalPrice|priceFormat}}</span>
          </li>
          <li>
            <span class="item-text">支付状态</span>
            <span class="item-value">{{userOrder|payStatus}}</span>
          </li>
          <li v-if="userOrder.tradeNo">
            <span class="item-text">交易单号</span>
            <span class="item-value">{{userOrder.tradeNo}}</span>
          </li>
          <li v-if="userOrder.tradeRequestTime">
            <span class="item-text">下单时间</span>
            <span class="item-value">{{userOrder.tradeRequestTime|dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
          </li>
          <li v-if="userOrder.tradeResponseTime">
            <span class="item-text">支付时间</span>
            <span class="item-value">{{userOrder.tradeResponseTime|dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="order-action">
      <van-cell title="项目详情" is-link />
      <van-cell title="体检须知" is-link @click="showNotice=true" />
    </div>

    <van-popup v-model="showNotice" round closeable position="bottom" :style="{height:'80%',paddingBottom:'48px'}">
      <div class="notice-wrapper">
        <p v-html="hospInfo.notice"></p>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .order-info {
    background: #fff;
    padding: 32px 24px;
    margin-bottom: 12px;
    text-align: center;

    .order-status {
      padding-bottom: 24px;
      margin-bottom: 24px;
      border-bottom: 1px solid #ebedf0;

      h3 {
        font-size: 20px;
        margin-top: 8px;
      }
    }

    .order-detail {
      text-align: left;
      font-size: 14px;

      li {
        list-style: none;
        display: flex;
        line-height: 32px;

        .item-text {
          width: 80px;
          color: #888;
        }

        .item-value {
          flex: 1;
        }
      }
    }
  }

  .order-action {
    padding: 12px;
    background: #fff;
  }

  .notice-wrapper {
    padding: 16px;
    padding-bottom: 48px;
    height: 60%;
  }
</style>

<script>
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";
  import JsBarcode from 'jsbarcode'
  export default {
    name: "orderInfo",
    data() {
      return {
        showNotice: false
      }
    },
    mounted() {
      console.log(this.$route.params);
      this.createBarcode();
    },
    filters: {
      orderStatus: function (value) {
        if (!value) return ''
        switch (value) {
          case 1:
            return "已预约"
            break;
          case 2:
            return "已体检"
            break;
          case 9:
            return "已取消"
            break;
          default:
            return ""
            break;
        }
      },
      payStatus: function (order) {
        if (order.payment == 0) {
          return "现场支付"
        } else {
          if (order.payStatus == 0) {
            return "未支付"
          } else if (order.payStatus == 1) {
            return "已支付"
          } else if (order.payStatus == 2) {
            return "退款中"
          } else if (order.payStatus == 3) {
            return "退款成功"
          } else if (order.payStatus == 9) {
            return "交易关闭"
          }
        }
      },
    },
    computed: {
      userOrder() {
        return this.$route.params
      },
      ...mapState({
        hospInfo: state => state.hospital.hospInfo
      })
    },
    methods: {
      createBarcode() {
        if (this.userOrder && this.userOrder.examUserCode) {
          JsBarcode("#barcode1", this.userOrder.examUserCode, {
            format: "CODE128", //条形码的格式
            width: 1.5, //线宽
            height: 70, //条码高度
            lineColor: "#000", //线条颜色
            displayValue: false, //是否显示文字
            margin: 2 //设置条形码周围的空白区域
          })
        }
      }
    },
  }
</script>